import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
export function BusinessModel() {
  return <Section background="ivory" data-id="element-34" data-mp="111ijev9wyf3b">
      <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-35" data-mp="112tn6v3czmuf">
        <FadeIn data-id="element-36" data-mp="nadhtnmzjcqc">
          <h2 className="text-4xl md:text-5xl font-serif text-charcoal mb-6" data-id="element-37" data-mp="navl3482er7r">
            A Multi-Layered Revenue Engine
          </h2>
          <p className="text-lg text-charcoal/70" data-id="element-38" data-mp="1fxzs1eqpxfm6">
            A sustainable, scalable model designed to capture value across the
            entire wellness ecosystem.
          </p>
        </FadeIn>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-39" data-mp="160246scrtku3">
        {/* Consumer */}
        <FadeIn delay={100} data-id="element-40" data-mp="1aywl1or6gzbk">
          <div className="bg-white p-10 rounded-3xl border border-purple-200 h-full flex flex-col transition-all duration-300 hover:shadow-xl hover:shadow-purple-200/30" data-id="element-41" data-mp="1ay3o1fi0to6m">
            <div className="text-sm uppercase tracking-widest text-purple-700 font-semibold mb-6" data-id="element-42" data-mp="3vp42dg54zvkm">
              Consumer (B2C)
            </div>
            <div className="mb-8 flex-grow" data-id="element-43" data-mp="26j91fbe4zbkc">
              <div className="mb-6" data-id="element-44" data-mp="22gvwuqb4ljp5">
                <div className="text-2xl font-serif text-charcoal mb-1" data-id="element-45" data-mp="22hxkrvd8q0oa">
                  Free Membership
                </div>
                <div className="text-sm text-charcoal/60" data-id="element-46" data-mp="2ghyjp59y2y14">
                  Entry layer access
                </div>
              </div>
              <div data-id="element-47" data-mp="2ph3i8bliarda">
                <div className="flex items-baseline mb-1" data-id="element-48" data-mp="2pgjzwtry20yq">
                  <span className="text-3xl font-serif text-charcoal" data-id="element-49" data-mp="2pez3szpze9yr">
                    $9.99
                  </span>
                  <span className="text-charcoal/50 ml-1" data-id="element-50" data-mp="2z6verbd61uke">/mo</span>
                </div>
                <div className="text-sm text-charcoal/80 font-medium mb-2" data-id="element-51" data-mp="2u81y5a2l1ng0">
                  Premium Tier
                </div>
                <ul className="space-y-2 text-sm text-charcoal/60" data-id="element-52" data-mp="394jdecdw7m7u">
                  <li data-id="element-53" data-mp="34683k1nllbpm">• AI wellness plans</li>
                  <li data-id="element-54" data-mp="347j3fqdx9zbg">• Advanced analytics</li>
                  <li data-id="element-55" data-mp="3b9fyajvuuprf">• Priority booking access</li>
                </ul>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* Practitioner */}
        <FadeIn delay={300} data-id="element-56" data-mp="3g8sjz1azpqsf">
          <div className="bg-purple-100/50 p-10 rounded-3xl border border-purple-300 h-full flex flex-col relative overflow-hidden transition-all duration-300 hover:shadow-xl hover:shadow-purple-200/30" data-id="element-57" data-mp="3l7lxuuu6vjt4">
            <div className="absolute top-0 right-0 w-32 h-32 bg-purple-200/30 rounded-full blur-2xl -mr-10 -mt-10" data-id="element-58" data-mp="3uxf6po2y5kto"></div>
            <div className="text-sm uppercase tracking-widest text-purple-700 font-semibold mb-6 relative z-10" data-id="element-59" data-mp="2suwpo5jyyyc">
              Practitioners (B2P)
            </div>
            <div className="mb-8 flex-grow relative z-10" data-id="element-60" data-mp="7qwhcdimn6bx">
              <div className="mb-6" data-id="element-61" data-mp="cqhh2q5mfipp">
                <div className="flex items-baseline mb-1" data-id="element-62" data-mp="cpg1q9hkoa26">
                  <span className="text-3xl font-serif text-charcoal" data-id="element-63" data-mp="29ldrm39sqg08">
                    $399
                  </span>
                  <span className="text-charcoal/50 ml-1" data-id="element-64" data-mp="2ejf9wlzeeban">/yr</span>
                </div>
                <div className="text-sm text-charcoal/80 font-medium" data-id="element-65" data-mp="2717hfdul9tb8">
                  Individual Practice
                </div>
              </div>
              <div data-id="element-66" data-mp="1x9bftstanl29">
                <div className="flex items-baseline mb-1" data-id="element-67" data-mp="1xawbjlrcha1p">
                  <span className="text-3xl font-serif text-charcoal" data-id="element-68" data-mp="1sarthrasg79d">
                    $2,550
                  </span>
                  <span className="text-charcoal/50 ml-1" data-id="element-69" data-mp="2pz1v456nwszy">/yr</span>
                </div>
                <div className="text-sm text-charcoal/80 font-medium mb-2" data-id="element-70" data-mp="2kzp02x5n0fma">
                  Group Practices
                </div>
                <ul className="space-y-2 text-sm text-charcoal/60" data-id="element-71" data-mp="2fz192bherys2">
                  <li data-id="element-72" data-mp="2b1rb27fyeesm">• Practice management tools</li>
                  <li data-id="element-73" data-mp="2b0zrxw3jm9j8">• Client analytics</li>
                  <li data-id="element-74" data-mp="14lp0jnaperzk">• Premium client acquisition</li>
                </ul>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* Enterprise */}
        <FadeIn delay={500} data-id="element-75" data-mp="zofg6m2696il">
          <div className="bg-charcoal p-10 rounded-3xl border border-charcoal h-full flex flex-col text-ivory transition-all duration-300 hover:shadow-xl hover:shadow-charcoal/30" data-id="element-76" data-mp="2ofqidsz5l0th">
            <div className="text-sm uppercase tracking-widest text-purple-400 font-semibold mb-6" data-id="element-77" data-mp="2ei41x227h17e">
              Enterprise (B2B)
            </div>
            <div className="mb-8 flex-grow" data-id="element-78" data-mp="2jhysf4i2jorx">
              <div className="mb-6" data-id="element-79" data-mp="376rpj4afg2o4">
                <div className="flex items-baseline mb-1" data-id="element-80" data-mp="377t2jeb06z8h">
                  <span className="text-3xl font-serif text-ivory" data-id="element-81" data-mp="3c5ujntovcohb">$3.99</span>
                  <span className="text-ivory/50 ml-1" data-id="element-82" data-mp="3c3rvzgb6v7fr">/user/mo</span>
                </div>
                <div className="text-sm text-ivory/80 font-medium mb-2" data-id="element-83" data-mp="2x8bzl4n4yzg7">
                  Corporate Wellness
                </div>
                <ul className="space-y-2 text-sm text-ivory/60" data-id="element-84" data-mp="1ltew4pq7g7pb">
                  <li data-id="element-85" data-mp="1ls3t4s4l33z9">• Employee wellness access</li>
                  <li data-id="element-86" data-mp="1qt1bb4plfy0r">• Aggregated analytics dashboards</li>
                  <li data-id="element-87" data-mp="1qqf4566m7kj2">• Workforce health insights</li>
                  <li data-id="element-88" data-mp="8ttupub6ardj">• Dedicated account management</li>
                </ul>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </Section>;
}